import Link from "next/link";
import fs from "fs";
import matter from "gray-matter";
import md from "markdown-it";
import { Card, Text, Title } from "@mantine/core";
import dayjs from "dayjs";
import Seo from "../../components/SEO";

export default function BlogList({ blogs }) {
  return (
    <div>
      <Seo title={"Blog"} description={`React Native Job's Blog`} />
      {blogs
        .sort((a, b) => dayjs(b.frontmatter.date).valueOf() - dayjs(a.frontmatter.date).valueOf())
        .map(({ slug, preview, frontmatter }) => (
          <Card key={slug} withBorder mb="sm">
            <Link href={`/blog/${slug}`}>
              <a>
                <Title order={2}>{frontmatter.title}</Title>
                <Text pt="sm" size={"sm"}>
                  {dayjs(frontmatter.date).format("MMM DD, YYYY")}
                </Text>
                <Text lineClamp={2}>{frontmatter.description}</Text>
              </a>
            </Link>
          </Card>
        ))}
    </div>
  );
}

export async function getStaticProps() {
  const files = fs.readdirSync("blog");

  const blogs = files.map((fileName) => {
    const slug = fileName.replace(".md", "");
    const readFile = fs.readFileSync(`blog/${fileName}`, "utf-8");
    const { data: frontmatter, content } = matter(readFile);
    return {
      slug,
      frontmatter,
    };
  });

  return {
    props: {
      blogs,
    },
  };
}
